import React from 'react';

const DynamicPieChart = ({ percentage, color, size = 40 }) => {
  // Clamp percentage between 0 and 100
  const validPercentage = Math.max(0, Math.min(100, percentage || 0));
  
  // Convert percentage to angle (360 degrees = 100%)
  const angle = (validPercentage / 100) * 360;
  
  // Calculate the end point of the arc
  const radius = 20;
  const centerX = 20;
  const centerY = 20;
  
  // Convert angle to radians for calculation
  const radians = (angle - 90) * (Math.PI / 180);
  const x = centerX + radius * Math.cos(radians);
  const y = centerY + radius * Math.sin(radians);
  
  // Determine if we need a large arc (>180 degrees)
  const largeArcFlag = angle > 180 ? 1 : 0;
  
  // Create the path
  let path;
  if (validPercentage === 0) {
    // No fill for 0%
    path = '';
  } else if (validPercentage === 100) {
    // Full circle for 100%
    path = `M ${centerX},${centerY} m 0,-${radius} a ${radius},${radius} 0 1,1 0,${radius * 2} a ${radius},${radius} 0 1,1 0,-${radius * 2}`;
  } else {
    // Pie slice for partial percentage
    path = `M ${centerX},${centerY} L ${centerX},${centerY - radius} A ${radius},${radius} 0 ${largeArcFlag},1 ${x},${y} Z`;
  }
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" width={size} height={size}>
      <circle cx={centerX} cy={centerY} r={radius} fill="#A9A9A9" fillOpacity={0.29} />
      {validPercentage > 0 && (
        <path fill={color} d={path} />
      )}
    </svg>
  );
};

export default DynamicPieChart;
